import { render } from "./ViceExamCam.vue?vue&type=template&id=8a313e9c"
import script from "./ViceExamCam.vue?vue&type=script&lang=js"
export * from "./ViceExamCam.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__